.payrollButton {
  box-shadow: none !important;

  &__cancel {
    min-width: 175px !important;
    &:hover:not([disabled]) {
      color: white !important;
    }
  }
}
